export default {
  env: "staging",
  partialURL: "https://test.edwhat.com/core/api/"
};
